import toggleItems from './toggleItems.js';

export default () => {
    const menu = document.querySelector('.header__navigation');
    const menuBtn = document.querySelector('.header__nav-btn');

    function toggleMenu(){
        if ( !menu.matches('.show')){
            menu.classList.add('show');
            menuBtn.setAttribute('aria-expanded', 'true');
        } else {
            menu.classList.remove('show');
            menuBtn.setAttribute('aria-expanded', 'false');
        }
    }

    menuBtn.addEventListener('click', toggleMenu);

    toggleItems(
        document.querySelector('.preheader button'),
        document.querySelector('.preheader__rems-dropdown-container')
    );
    document.querySelectorAll('.nav__item.nav__has-submenu button').forEach( (btn) => {
        toggleItems(btn, btn.nextElementSibling);
    });
};
